import { mapState, mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import store from '@state/store'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    currentWell: (state) => state.currentWell,
  }),
  ...mapGetters('auth', ['loggedIn', 'userRole', 'hasPriv', 'unitStandard']),
}
export const fieldComputed = {
  ...mapState('field', {
    wellList: (state) => state.wellList,
    fieldList: (state) => state.fieldList,
    padList: (state) => state.padList,
  }),
  ...mapGetters('field', ['fieldData', 'padData', 'wellData']),
}
export const userComputed = {
  ...mapState('users', {
    userList: (state) => state.userList,
    roleList: (state) => state.roleList,
  }),
  ...mapGetters('users', ['roleList', 'userList']),
}
export const accountComputed = {
  ...mapState('account', {
    accountList: (state) => state.accountList,
    currentClientDetail: (state) => state.currentClientDetail,
  }),
  ...mapGetters('account', ['organizationList']),
}
export const formComputed = {
  ...mapState('form', {
    dailyDrillingReport: (state) => state.dailyDrillingReport,
    diameterOptions: (state) => state.diameterOptions,
  }),
  ...mapGetters('form', [
    'masterSurveyList',
    'dailyDrillingReport',
    'plannerCCB',
    'plannerCGC',
    'plannerCI',
    'plannerCost',
    'plannerCostUnit',
    'plannerActivity',
    'plannerActivityCost',
    'plannerActivityCostAll',
    'dailyDrillingGeneral',
    'dailyDrillingCurrentSelected',
    'comboWellbore',
    'comboRigOps',
    'dailyDrillingPersonal',
    'dailyDrillingSimplyHoleSection',
    'diameterOptions'
  ]),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'setUser',
  'setAvatar',
  'register',
  'resetPassword',
])

export const fieldMethods = mapActions('field', [
  'getWellStatus',
  'getWellInfo',
  'getFields',
  'getPads',
  'getWells',
  'getWellList',
  'getFieldList',
  'getPadList',
  'addField',
  'addPad',
  'addWell',
  'updateField',
  'updatePad',
  'updateWell',
  'deleteField',
  'deletePad',
  'deleteWell',
])

export const userMethods = mapActions('users', [
  'getUserList',
  'getRoleList',
  'setUserList',
  'addUser',
  'updateUser',
  'deleteUser',
  'setRoleList',
  'changeAvatar',
  'changePassword',
])

export const accountMethods = mapActions('account', [
  'getClientList',
  'setClientList',
  'addClient',
  'updateClient',
  'deleteClient',
])

export const formMethods = mapActions('form', [
  'getOpsSumMaxDate',
  'getGeneralLotfitBySubmitId',
  'getDashboardTimelineProgress',
  'getDashboardCostPerContract',
  'getDashboardCostActualVsPlan',
  'getDashboardAfevsActual',
  'getDashboardActivityBreakdown',
  'getDashboardNptHoleSection',
  'getDashboardDays10k',
  'getDashboardDvdvcPlan',
  'getDashboardPtNpt',
  'getDashboardNptBreakdown',
  'getDashboardDvd',
  'getDashboardDvc',
  'getDashboardWellPlaneView',
  'getSubsurfaceByWell',
  'getDashboardDrillingParameters',
  'getDrillingParametersFormList',

  'getActivityGeneralWorkByWell',
  'getActivityGeneralWorkOpsByWell',

  'getActivityWellTestByWell',

  'getActivityFishingWellboreObsByWell',
  'getActivityFishingStringShotByWell',
  'getActivityFishingRespPartByWell',
  'getActivityFishingResultByWell',
  'getActivityFishingFreePointByWell',
  'getActivityFishingGeneralByWell',

  'getActivityLoggingIntervalByWell',
  'getActivityLoggingByWell',

  'getActivityCoringSidewallByWell',
  'getActivityCoringByWell',

  'getActivityCementIsolatedIntervalByWell',
  'getActivityCementIntCirculationByWell',
  'getActivityCementStageByWell',
  'getActivityCementFluidByWell',
  'getActivityCementFixByWell',

  'getActivityKickByWell',
  'getActivityCasingByWell',
  'getActivityGeneralWorkJobType',
  'removeSubsurfaceFormReport',
  'updateSubsurfaceFormReport',
  'addSubsurfaceFormReport',
  'getSubsurfaceReportResultList',
  'getSubsurfaceAlterationTypeList',
  'removeReportSubsurface',
  'submitReportSubsurface',
  'updateReportSubsurface',
  'getSubsurfaceReportList',
  'addReportSubsurface',

  'getActivityReportListWithStatus',

  'addReportDailyDrilling',
  'getDailyDrillingReportList',
  'updateReportDailyDrilling',
  'submitReportDailyDrilling',
  'removeReportDailyDrilling',

  'removeActivityGeneralWorkOps',
  'addActivityGeneralWorkFix',
  'addActivityGeneralWorkOps',
  'updateActivityGeneralWorkFix',
  'updateActivityGeneralWorkOps',
  'getActivityGeneralWorkFix',
  'getActivityGeneralWorkOps',

  'getActivityWellTest',
  'updateActivityWellTest',
  'addActivityWellTest',

  'removeActivityFishingGeneral',
  'removeActivityFishingFreePoint',
  'removeActivityFishingResult',
  'removeActivityFishingResponsibleParties',
  'removeActivityFishingStringShot',
  'removeActivityFishingWellboreObstruction',
  'addActivityFishingGeneral',
  'addActivityFishingFreePoint',
  'addActivityFishingResult',
  'addActivityFishingResponsibleParties',
  'addActivityFishingStringShot',
  'addActivityFishingWellboreObstruction',
  'updateActivityFishingGeneral',
  'updateActivityFishingFreePoint',
  'updateActivityFishingResult',
  'updateActivityFishingResponsibleParties',
  'updateActivityFishingStringShot',
  'updateActivityFishingWellboreObstruction',
  'getActivityFishingGeneral',
  'getActivityFishingFreePoint',
  'getActivityFishingResult',
  'getActivityFishingResponsibleParties',
  'getActivityFishingStringShot',
  'getActivityFishingWellboreObstruction',

  'getComboOptionList',

  'removeActivityLoggingInterval',
  'addActivityLoggingInterval',
  'addActivityLogging',
  'updateActivityLoggingInterval',
  'updateActivityLogging',
  'getActivityLoggingInterval',
  'getActivityLogging',
  'removeActivityCoringSidewallDesc',
  'removeActivityCoringDesc',
  'addActivityCoringSidewallDesc',
  'addActivityCoringDesc',
  'addActivityCoring',
  'updateActivityCoringSidewallDesc',
  'updateActivityCoringDesc',
  'updateActivityCoring',
  'getActivityCoringSidewallDesc',
  'getActivityCoringDesc',
  'getActivityCoring',
  'removeActivityCementPumpSch',
  'updateActivityCementPumpSch',
  'addActivityCementPumpSch',
  'removeActivityCementIsoInt',
  'updateActivityCementIsoInt',
  'addActivityCementIsoInt',
  'removeActivityCementIntCirculation',
  'updateActivityCementIntCirculation',
  'addActivityCementIntCirculation',
  'removeActivityCementStage',
  'updateActivityCementStage',
  'addActivityCementStage',
  'getActivityStageNoList',
  'removeActivityCementFluid',
  'addActivityCementFluid',
  'updateActivityCementFluid',
  'getActivityTypeList',
  'getActivityPurposeList',
  'getActivityDescriptionList',
  'getActivityClassList',
  'getActivityFluidNameList',
  'addActivityCementFix',
  'updateActivityCementFix',

  'getActivityCementFix',
  'getActivityCementFluid',
  'getActivityCementStage',
  'getActivityCementIntCirculation',
  'getActivityCementIsoInt',
  'getActivityCementPumpSch',

  'updateActivityDatabaseCasing',
  'updateActivityDatabaseCasingTally',
  'updateActivityDatabaseCoring',
  'updateActivityDatabaseCoringDesc',
  'updateActivityDatabaseCoringSidewallDesc',

  'getComboListJobType',
  'addActivityKick',
  'updateActivityKick',
  'getActivityKick',
  'getComboListKickProc',
  'getComboListKickClass',
  'getComboListKickOccur',
  'removeActivityCasingTally',
  'updateActivityCasingTally',
  'addActivityCasingTally',
  'getComboListGrade',
  'getComboListAssemblyType',
  'getActivityCasingTallyList',
  'submitReportActivity',
  'removeReportActivity',
  'updateReportActivity',
  'addReportActivity',
  'removeActivityCasing',
  'updateActivityCasing',
  'addActivityCasing',
  'getComboListTabularType',
  'getComboListCasingSize',
  'getActivityCasingList',
  'getActivityReportList',
  'getMasterDDRGetPrevMD',
  'addMasterDDRGeneral',
  'updateMasterDDRGeneral',
  'getMasterDDRGeneral',
  'getMasterLotfitByWell',
  'getMasterLotfitPumpByWell',
  'getMasterShsByWell',
  'getMasterSurveyByWell',
  'getMasterMudByWell',
  'getMasterBulkByWell',
  'removeMasterMud',
  'getMasterEnvActivityDisposalByWell',
  'getMasterEnvActivityRecoveryByWell',
  'getMasterEnvActivityDischargeByWell',
  'getMasterEnvActivitySpillByWell',
  'getMasterEnvActivityCuttingByWell',
  'getMasterSafetyIncidentByWell',
  'getMasterSafetyByWell',
  'getMasterWorkstringBitDataByWell',
  'getMasterWorkstringBHAByWell',
  'getMasterWorkstringBHAContentByWell',
  'getMasterCostByWell',
  'getMasterCostCarryOver',
  'getMasterOpsumByWell',
  'getMasterPersonalByWell',
  'getMasterLastPersonalList',
  'removeMasterPersonalBySubmitId',
  'getMasterGeneralByWell',
  'getMasterDolByWell',
  'getMasterDfsByWell',
  'updateApprovalStatus',
  'getDailyDrillingWitingForApproval',
  'getComboListCompany',
  'removeMasterPersonal',
  'updateMasterPersonal',
  'addMasterPersonal',
  'getMasterPersonalList',
  'removeMasterOpsum',
  'updateMasterOpsum',
  'addMasterOpsum',
  'getMasterOpsum',
  'getComboOptionPhasecode',
  'getComboOptionActivitycode',
  'getComboOptionSubactivitycode',
  'getComboOptionActivitycategory',
  'getComboOptionNptcode',
  'getComboListActivityCategory',
  'getComboListContractBundle',
  'getComboListGeneralComponent',
  'getComboListCostItem',
  'removeMasterCost',
  'updateMasterCost',
  'addMasterCost',
  'getMasterCostList',
  'getComboListWorkstringSectionType',
  'getComboListWorkstringComponentType',
  'getComboListBitNo',
  'getComboListWorkstringReasonPulled',
  'getComboListWorkstringOtherDullChar',
  'getComboListWorkstringGauge',
  'getComboListWorkstringBearingSeals',
  'getComboListWorkstringLocation',
  'getComboListWorkstringDullChar',
  'getComboListWorkstringOuterRow',
  'getComboListWorkstringInnerRow',
  'getComboListWorkstringSize',
  'getComboListWorkstringDrillMode',
  'removeMasterWorkstringBitData',
  'removeMasterWorkstringBha',
  'removeMasterWorkstringBhaContent',
  'updateMasterWorkstringBitData',
  'updateMasterWorkstringBha',
  'updateMasterWorkstringBhaContent',
  'addMasterWorkstringBitData',
  'addMasterWorkstringBha',
  'addMasterWorkstringBhaContent',
  'getMasterWorkstringBhaContentList',
  'getMasterWorkstringBhaList',
  'getMasterWorkstringBitDataList',
  'removeMasterEnvActivityDischarge',
  'removeMasterEnvActivityRecovery',
  'removeMasterEnvActivityDisposal',
  'removeMasterEnvActivitySpill',
  'removeMasterEnvActivityCutting',
  'addMasterEnvActivityDischarge',
  'addMasterEnvActivityRecovery',
  'addMasterEnvActivityDisposal',
  'addMasterEnvActivitySpill',
  'addMasterEnvActivityCutting',
  'updateMasterEnvActivityDischarge',
  'updateMasterEnvActivityRecovery',
  'updateMasterEnvActivityDisposal',
  'updateMasterEnvActivitySpill',
  'updateMasterEnvActivityCutting',
  'getMasterEnvActivityDischargeList',
  'getMasterEnvActivityRecoveryList',
  'getMasterEnvActivityDisposalList',
  'getMasterEnvActivitySpillList',
  'getMasterEnvActivityCuttingList',
  'removeMasterSafetyIncident',
  'addMasterSafetyIncident',
  'updateMasterSafetyIncident',
  'addMasterSafety',
  'updateMasterSafety',
  'getMasterSafety',
  'getMasterSafetyIncident',
  'removeMasterBulk',
  'updateMasterBulk',
  'getComboListBulkUnitSize',
  'addMasterBulk',
  'getMasterBulkList',
  'updateMasterMud',
  'getMasterMud',
  'addMasterMud',
  'getMasterSurveyList',
  'getComboListSurveyStationType',
  'removeMasterSurvey',
  'updateMasterSurvey',
  'addMasterSurvey',
  'removeMasterSHS',
  'updateMasterSHS',
  // 'getMasterSHSList',
  'addMasterSHS',
  'removeMasterLotfitPump',
  'updateMasterLotfitPump',
  'addMasterLotfitPump',
  'removeMasterLotfit',
  'updateMasterLotfit',
  'removeMasterDrillingParameters',
  'addMasterLotfit',
  'getGeneralLotfit',
  'getGeneralLotfitPump',
  'getDailyDrillingSimplyHoleSection',
  'getDailyDrillingReport',
  'getPlannerCostContractBundle',
  'getPlannerCostGeneralComponent',
  'getPlannerCostItem',
  'getPlannerCost',
  'getPlannerCostUnit',
  'getPlannerActivity',
  'updatePlannerActivity',
  'getPlannerActivityCost',
  'updatePlannerActivityCost',
  'getPlannerActivityCostAll',
  'setPlannerCostGeneralComponent',
  'setPlannerCostItem',
  'setPlannerActivityCost',
  'addPlannerCostContractBundle',
  'updatePlannerCostContractBundle',
  'deletePlannerCostContractBundle',
  'getPlannerCostItemAll',
  'addPlannerCostGeneralComponent',
  'updatePlannerCostGeneralComponent',
  'updatePlannerCostItem',
  'deletePlannerCostGeneralComponent',
  'addPlannerCostItem',
  'deletePlannerCostItem',
  'addPlannerActivity',
  'deletePlannerActivity',
  'addPlannerActivityCost',
  'deletePlannerActivityCost',
  'addPlannerCostUnit',
  'getDailyDrillingGeneral',
  'setDailyDrillingGeneral',
  'getDailyDrillingCurrentSelected',
  'setDailyDrillingCurrentSelected',
  'setDailyDrillingReport',
  'addDailyDrillingReport',
  'addDailyDrillingGeneral',
  'uploadDailyDrillingGeneral',
  'downloadTemplate',
  'updateDailyDrillingGeneral',
  'getComboWellbore',
  'setComboWellbore',
  'getComboRigOps',
  'setComboRigOps',
  'getDailyDrillingPersonal',
  'addDailyDrillingPersonal',
  'updateStatus',
  'getComboCementStageType',
  'getDashboardBitPerformance',
  'getDashboardWellGraph',
  'getLogs',
  'getSubmittedReportListMap',
  'getSubmittedReportContext',
  'getSubmittedCostReport',
  'getOpsumByWell'
])

export const getSavedState = (key) => {
  return JSON.parse(window.localStorage.getItem(key))
}

export const saveState = (key, state) => {
  window.localStorage.setItem(key, JSON.stringify(state))
}

export const setDefaultAuthHeaders = (state) => {
  // axios.defaults.baseURL = 'http://103.56.149.87';
  axios.defaults.headers.common.Authorization = state.currentUser
    ? 'Bearer ' + state.currentUser.token
    : ''
  axios.interceptors.response.use(undefined, (error) => {
    if (error.response.status === 401) {
      store.dispatch('auth/logOut')
      window.location = '/login'
      return Promise.reject(error)
    } else {
      // return error
      let message = "An unknown error occurred.";

      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        message = "The server took too long to respond. Please try again.";
      } else if (error.response && error.response.data) {
        message = error.response.data.message || "Server Error";
      } else {
        message = error.message;
      }
    
      return Promise.reject(message); 
    }
  })
}
